const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          suppliers: 'Flotten',
        },
      },
    },
  },
};

export default layout;